<template>
  <div class="mt-6 no-overflow">
    <v-list class="mt-11" color="#f6f5f4" max-width="300" dense rounded nav>
      <v-list-item-group>
        <v-list-item
          active-class="active-side-nav"
          v-for="(nav, index) in getNavTitles()"
          :key="index"
          :to="{ name: 'account', hash: getHash(nav.title) }"
        >
          <v-list-item-content>
            <v-list-item-title
              class="pl-2 text-subtitle-1"
              v-text="nav.title"
            ></v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon>
            <!-- <v-icon v-text="'mdi-clock'"></v-icon> -->
            <Icon
              v-if="nav.icon"
              :name="nav.icon"
              :color="$vuetify.theme.themes.light.secondary"
              :title="nav.title"
              :style="{ height: '26px', width: '26px' }"
              :class="$route.hash === '#rewards' ? 'active-side-nav-image' : ''"
            ></Icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item @click="logout">
          <v-list-item-content>
            <v-list-item-title
              class="pl-2 text-subtitle-1"
              v-text="'Log Out'"
            ></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <LegalLinksNav class="pl-4" />
  </div>
</template>

<script>
import LegalLinksNav from "@/components/Navigation/LegalLinks.vue";
import Icon from "@/components/UI/Icon.vue";
import { mapGetters, mapState } from "vuex";

export default {
  name: "AccountSideNav",
  components: { Icon, LegalLinksNav },
  computed: {
    ...mapGetters("store", {
      rewardsAvailable: "rewardsAvailable",
    }),
    ...mapState({
      websiteFormat: (state) =>
        state.store.info.store_info.customization?.website.style
          .website_format ?? "all_items",
    }),
  },
  data() {
    return {
      includeLoyalty:
        process.env.VUE_APP_INCLUDE_LOYALTY.toLowerCase() === "true",
    };
  },
  methods: {
    getHash(nav) {
      const navToHashMap = {
        Orders: "#orders",
        "My Profile": "#profile",
        Rewards: "#rewards",
        About: "#about",
        Support: "#support",
      };
      return navToHashMap[nav] || "#profile";
    },
    getNavTitles() {
      let titles = this.$options.navTitles.map((t) => {
        if (t.title === "Rewards" && !this.rewardsAvailable) {
          t.icon = null;
        }
        return t;
      });
      if (this.websiteFormat === "store_info_rewards") {
        titles = titles.filter((t) => {
          return !(t.title === "About" || t.title === "Orders");
        });
      }

      return titles.filter((t) => {
        return !(!this.includeLoyalty && t.title === "Rewards");
      });
    },
    logout() {
      this.$store.dispatch("auth/logout");
    },
  },
  navTitles: [
    { title: "My Profile" },
    { title: "Rewards", icon: "crownrewards" },
    { title: "Orders" },
    { title: "About" },
    { title: "Support" },
  ],
};
</script>

<style scoped>
.active-side-nav {
  background-color: var(--v-primary-base);
  color: var(--color-white) !important;
}
.active-side-nav-image {
  filter: brightness(0) invert(1);
}
</style>
